import React from 'react';
import AdminReports from './AdminReports';
import MerchantReports from './MerchantReports';
import ManagerReports from './ManagerReports';
import StaffReports from './StaffReports';

interface ReportsProps {
  role: 'admin' | 'merchant' | 'merchant_manager' | 'merchant_staff';
}

const Reports: React.FC<ReportsProps> = ({ role }) => {
  return (
    <div>
      {role === 'admin' && <AdminReports />}
      {role === 'merchant' && <MerchantReports />}
      {role === 'merchant_manager' && <ManagerReports />}
      {role === 'merchant_staff' && <StaffReports />}
    </div>
  );
};

export default Reports;
